import * as React from 'react'
import {FC} from 'react'
import Form from 'antd/lib/form'
import 'antd/lib/form/style'
import Divider from 'antd/lib/divider'
import 'antd/lib/divider/style'
import {FormInstance} from 'antd/lib/form'
import GlobalOutlined from '@ant-design/icons/lib/icons/GlobalOutlined'
import IDS from '../../constants/ids'
import './index.less'
import divideIntegerBySpace from '../../../../../../../src/js/common/helpers/divideIntegerBySpace'
import {CargoTypes} from '../../types/models/cargo-types'

const {Item} = Form

interface CheckPropsInterface {
    cargoTypes: CargoTypes
    percent: number
}

const Check: FC<CheckPropsInterface> = ({cargoTypes, percent}) => {
    return (
        <Item shouldUpdate={true} noStyle>
            {(form: FormInstance) => {
                const {getFieldValue} = form,
                    insuranceSum = getFieldValue(IDS.INSURANCE_SUM),
                    distanceArea = getFieldValue(IDS.DISTANCE_AREA),
                    selectedCargoId = getFieldValue(IDS.CARGO_TYPE),
                    franchiseSelected = getFieldValue(IDS.FRANCHISE),
                    franchise = selectedCargoId
                        ? cargoTypes.find(cargoType => cargoType.id === selectedCargoId).franchise
                        : '0',
                    coverInsurance = insuranceSum
                        ? `${divideIntegerBySpace(parseInt(insuranceSum))} руб.`
                        : `0 руб.`,
                    coverArea = distanceArea === 'russia' ? `Россия` : `Весь мир`

                return (
                    <>
                        <h2>Ваш тариф</h2>
                        <Divider />
                        <p>
                            <GlobalOutlined className={'check__icon'} /> <b>{coverArea}</b>
                        </p>
                        <p>
                            Покрытие: <b>{coverInsurance}</b>
                        </p>
                        <p>
                            Страховой тариф: <b>{Number(percent + 'e2').toFixed(3)}%</b>
                        </p>
                        {franchiseSelected ? (
                            <p>
                                Безусловная франшиза: <b>{franchise}%</b>
                            </p>
                        ) : null}

                        <Divider />
                    </>
                )
            }}
        </Item>
    )
}

export default Check
